function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17 0C17.7585 0 18.3734 0.614922 18.3734 1.37341V7.62403C18.3734 8.38253 17.7585 8.99745 17 8.99745C16.2414 8.99745 15.6266 8.38253 15.6266 7.62403V1.37341C15.6266 0.614922 16.2414 0 17 0Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17 25.0024C17.7585 25.0024 18.3734 25.6173 18.3734 26.3759V32.6265C18.3734 33.385 17.7585 33.9999 17 33.9999C16.2414 33.9999 15.6266 33.385 15.6266 32.6265V26.3759C15.6266 25.6174 16.2414 25.0024 17 25.0024Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.6545 9.40321L27.0769 4.98089C27.6132 4.44452 28.4828 4.44452 29.0191 4.98089C29.5555 5.51718 29.5555 6.38677 29.0191 6.92314L24.5968 11.3455C24.3286 11.6136 23.9771 11.7478 23.6256 11.7478C23.2741 11.7478 22.9226 11.6137 22.6545 11.3455C22.1182 10.8092 22.1182 9.93958 22.6545 9.40321Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.98095 27.0768L9.40327 22.6545C9.93963 22.1181 10.8092 22.1181 11.3456 22.6545C11.8819 23.1908 11.8819 24.0604 11.3456 24.5968L6.92326 29.0191C6.65511 29.2873 6.30356 29.4214 5.95207 29.4214C5.60058 29.4214 5.24903 29.2873 4.98088 29.0191C4.44465 28.4828 4.44465 27.6132 4.98095 27.0768Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M26.376 15.6267H32.6266C33.3851 15.6267 34 16.2416 34 17.0001C34 17.7587 33.3851 18.3735 32.6266 18.3735H26.376C25.6175 18.3735 25.0026 17.7587 25.0026 17.0001C25.0025 16.2416 25.6175 15.6267 26.376 15.6267Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M1.3734 15.6267H7.62402C8.38258 15.6267 8.99744 16.2416 8.99744 17.0001C8.99744 17.7587 8.38258 18.3735 7.62402 18.3735H1.3734C0.614842 18.3735 -1.33514e-05 17.7587 -1.33514e-05 17.0001C-1.33514e-05 16.2416 0.614842 15.6267 1.3734 15.6267Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M22.6545 22.6545C23.1908 22.1181 24.0605 22.1181 24.5968 22.6545L29.0191 27.0768C29.5555 27.6132 29.5555 28.4828 29.0191 29.0191C28.751 29.2873 28.3994 29.4214 28.0479 29.4214C27.6964 29.4214 27.3449 29.2873 27.0768 29.0191L22.6545 24.5968C22.1182 24.0604 22.1182 23.1908 22.6545 22.6545Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M4.98095 4.98089C5.51731 4.44452 6.3869 4.44452 6.92326 4.98089L11.3456 9.40321C11.8819 9.93951 11.8819 10.8091 11.3456 11.3455C11.0774 11.6136 10.7259 11.7478 10.3744 11.7478C10.0229 11.7478 9.67141 11.6137 9.4032 11.3455L4.98088 6.92314C4.44465 6.38684 4.44465 5.51725 4.98095 4.98089Z",
  fill: "white"
});

var SvgLoading = function SvgLoading(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoading, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loading.8def26af.svg";
export { ForwardRef as ReactComponent };